import { join } from 'light-component';
import { Struct } from 'shoteyes-types';
import { Tag } from 'antd';
import { Icons } from 'zf-web-components/icons';
import { Block } from '../../../block';
import { Box } from '../../../box';
import { useTranslation } from '../../../i18n';
import styles from '../style.module.less';
import { Highlighter } from '../../component';
import { CheckBoxComponent } from './checkbox';
import type { CheckBoxProps } from './types';
import type { ReactElement } from 'react';

export function CheckBoxPropsViewMode(props: CheckBoxProps): ReactElement {
  const [t] = useTranslation();
  if (props?.formType === Struct.FormType.ANSWER) {
    return (
      <Box className={styles.viewBox}>
        <Box className={join(styles.subject, styles.input)}>
          <Block if={props.ok != null}>
            {props.ok === true
              ? <Icons name='CheckOutlined' style={{ color: '#77C06E' }} />
              : <Icons name='CloseOutlined' style={{ color: '#F47F7F' }} />
            }
          </Block>
          <Block if={props.number != null}>{props.number}、</Block>
          <Block if={props.typeName != null}>
            <Tag color='#ff943f'>{props.typeName}</Tag>
          </Block>
          <Highlighter
            title={props.title}
            keyword={props.keyword}
            className={styles.title}
          />

          <Block if={props.realScore != null && props.score != null}>
            <span className={styles.score} style={{ color: props.ok === true ? 'inherit' : '#f47f7f' }}>
              {`(${props.realScore}/${props.score})`}
            </span>
          </Block>
        </Box>
        <Box className={join(styles.viewContent, styles.inputContent, styles.answerBox)}>
          <CheckBoxComponent {...props} />
          <div className={styles.mb10}>
            {t('提交答案{answer}', { answer: (props.value ?? []).join('，') })}
          </div>
          <div className={styles.mb10}>
            {t('正确{answer}', { answer: props.rightAnswers })}
          </div>
          <Block if={props.specification != null && props.specification?.length > 0}>
            <div>{t('答案解析')}：</div>
            <div
              // 保留原有样式，不使用module
              className='ql-editors no-border'
              data-gramm='false'
              dangerouslySetInnerHTML={{ __html: props.specification ?? '' }}
            />
          </Block>
        </Box>
      </Box>);
  }
  return (
    <Box className={styles.viewBox}>
      <Box className={join(styles.subject, styles.input)}>
        <Highlighter
          title={props.title}
          keyword={props.keyword}
          className={styles.title}
        />
      </Box>
      <Box className={join(styles.content, styles.inputContent)}>
        <CheckBoxComponent {...props} />
      </Box>
    </Box>
  );
}
